import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Box, Typography, useMediaQuery } from "@mui/material";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../../Component/Common/ReuseableComponent/DetailCardComp";
export const NotificationVariance = ({ data = [], onClick = () => {} }) => {
  const vMediaQuery = useMediaQuery("(max-width: 600px)");
  return (
    <Box
      sx={{
        height: vMediaQuery ? "65vh" : "75vh",
        overflowY: "auto",
        py: vMediaQuery ? "0px" : "8px",
        px: vMediaQuery ? "0px" : "10px",
      }}
    >
      <Grid container spacing={1}>
        {Array.isArray(data) &&
          data.length > 0 &&
          data.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <DetailCardComp
                data={item}
                onClick={() => {
                  onClick({ row: item });
                }}
                headerLabel={item.Name1}
                content={
                  <Grid container spacing={1}>
                    <DetailInputDisplay label="Bin Code" value={item.BinCd} />
                    <DetailInputDisplay label="Qty" value={item.Qty} />
                    <DetailInputDisplay
                      label="Packed Qty"
                      value={item.PkdQty}
                    />
                    <DetailInputDisplay label="Diff" value={item.Diff} />
                  </Grid>
                }
              />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};
